import Image from './Image'

export default class CheckinContent {
  title = undefined
  content = undefined
  enable_table_booking = undefined
  book_button_copy = undefined
  image = new Image()


  constructor (source = undefined) {
    this.raw = source
    if(source) {
      this.parseSource(source)
    }
  }

  parseSource (source) {
    for (const prop in source) {
      if(prop in this) {
        this[prop] = source[prop]
      }
    }
    if (source.image) {
      this.image = new Image(source.image)
    }
  }

  hasContent() {
    return this.title || this.description
  }

}
